import * as Sentry from '@sentry/nextjs';
import { SENTRY_DSN } from '../constants';
import { isSentryEnabled } from '../services/sentry';

export const initializeSentryClient = (env_name: string): void => {
	Sentry.init({
		dsn: SENTRY_DSN,

		// Add optional integrations for additional features
		integrations: [Sentry.replayIntegration(), Sentry.browserProfilingIntegration()],

		// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
		tracesSampleRate: 0.1,

		profilesSampleRate: 0.1,

		// Define how likely Replay events are sampled.
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: 0.1,

		// Define how likely Replay events are sampled when an error occurs.
		replaysOnErrorSampleRate: 0.1,

		// Setting this option to true will print useful information to the console while you're setting up Sentry.
		debug: env_name !== 'production',
		environment: env_name,
		beforeSend(event) {
			if (!isSentryEnabled()) {
				// return null to discard the event
				return null;
			}
			// send event when enabled
			return event;
		},
	});
};
